module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-doctors"
  }, [_c('div', {
    staticClass: "custom-home-doctors__container-desktop"
  }, [_c('div', {
    staticClass: "custom-home-doctors__texts"
  }, [_c('div', {
    staticClass: "custom-home-doctors__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-home-doctors__text-group"
  }, [_c('div', {
    staticClass: "custom-home-doctors__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.first_text)
    }
  }), _c('div', {
    staticClass: "custom-home-doctors__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.second_text)
    }
  })])]), _c('div', {
    staticClass: "custom-home-doctors__tiles"
  }, [_c('div', {
    staticClass: "custom-home-doctors__tile",
    style: ({
      backgroundImage: 'url(' + _vm.props.first_image + ')'
    }),
    on: {
      "click": _vm.goToDrHingle
    }
  }, [_c('div', {
    staticClass: "custom-home-doctors__overlay"
  }), _c('div', {
    staticClass: "custom-home-doctors__learn-more"
  }, [_vm._v("Learn More about Dr. Hingle >")])]), _c('div', {
    staticClass: "custom-home-doctors__tile",
    style: ({
      backgroundImage: 'url(' + _vm.props.second_image + ')'
    }),
    on: {
      "click": _vm.goToDrPatel
    }
  }, [_c('div', {
    staticClass: "custom-home-doctors__overlay"
  }), _c('div', {
    staticClass: "custom-home-doctors__learn-more"
  }, [_vm._v("Learn More about Dr. Patel >")])])]), _c('div', {
    staticClass: "custom-home-doctors__banner",
    style: ({
      backgroundImage: 'url(' + _vm.props.banner + ')'
    })
  }, [_c('div', {
    staticClass: "custom-home-doctors__banner-box-max"
  }, [_c('div', {
    staticClass: "custom-home-doctors__banner-box"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointText
      }),
      expression: "{ active: true, callback: onWaypointText }"
    }],
    staticClass: "custom-home-doctors__waypoint"
  }), _c('div', {
    staticClass: "custom-home-doctors__banner-text",
    class: {
      'fade': _vm.fadeText
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.banner_text)
    }
  }), _c('div', {
    staticClass: "custom-home-doctors__schedule-now",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Schedule Now")])])])])]), _c('div', {
    staticClass: "custom-home-doctors__container-mobile"
  }, [_c('div', {
    staticClass: "custom-home-doctors__texts"
  }, [_c('div', {
    staticClass: "custom-home-doctors__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-home-doctors__image",
    style: ({
      backgroundImage: 'url(' + _vm.props.first_image + ')'
    }),
    on: {
      "click": _vm.goToDrHingle
    }
  }), _c('div', {
    staticClass: "custom-home-doctors__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.first_text)
    }
  }), _c('div', {
    staticClass: "custom-home-doctors__image",
    style: ({
      backgroundImage: 'url(' + _vm.props.second_image + ')'
    }),
    on: {
      "click": _vm.goToDrPatel
    }
  }), _c('div', {
    staticClass: "custom-home-doctors__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.second_text)
    }
  })]), _c('div', {
    staticClass: "custom-home-doctors__banner",
    style: ({
      backgroundImage: 'url(' + _vm.props.banner + ')'
    })
  }, [_c('div', {
    staticClass: "custom-home-doctors__banner-box-max"
  }, [_c('div', {
    staticClass: "custom-home-doctors__banner-box"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointText
      }),
      expression: "{ active: true, callback: onWaypointText }"
    }],
    staticClass: "custom-home-doctors__waypoint"
  }), _c('div', {
    staticClass: "custom-home-doctors__banner-text",
    class: {
      'fade': _vm.fadeText
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.banner_text)
    }
  }), _c('div', {
    staticClass: "custom-home-doctors__schedule-now",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Schedule Now")])])])])]), _c('transition', {
    attrs: {
      "name": "fade-in-modal"
    }
  }, [(_vm.showModal) ? _c('ModalSchedule', {
    on: {
      "closeScheduleModal": _vm.closeScheduleModal
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ad075b3","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-doctors/custom-home-doctors.pug
// module id = 564
// module chunks = 1